export default function capitalizeFirstLetter(text) {
  return text ? text.charAt(0).toUpperCase() + text.slice(1) : text;
};
